// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  ShopOutlined,
  AppstoreAddOutlined,
  HomeOutlined,
  UserOutlined,
  DashboardOutlined,
  MailOutlined,
  NotificationOutlined,
  QuestionCircleOutlined,
  BugOutlined,
} from "@ant-design/icons";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  ShopOutlined,
  AppstoreAddOutlined,
  HomeOutlined,
  UserOutlined,
  DashboardOutlined,
  MailOutlined,
  NotificationOutlined,
  QuestionCircleOutlined,
  BugOutlined,
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other: NavItemType = {
  id: "Menu",
  title: <FormattedMessage id="Menu" />,
  type: "group",
  children: [
    {
      id: "stores",
      breadcrumbs: false,
      title: <FormattedMessage id="stores" />,
      type: "item",
      url: "/stores",
      icon: icons.ShopOutlined,
    },
    {
      id: "add-store",
      breadcrumbs: false,
      title: <FormattedMessage id="add-store" />,
      type: "item",
      url: "/add-store",
      icon: icons.AppstoreAddOutlined,
    },
    {
      id: "dashboard",
      title: <FormattedMessage id="dashboard" />,
      type: "item",
      url: "/admin/dashboard",
      icon: icons.DashboardOutlined,
    },
    {
      id: "adminStores",
      title: <FormattedMessage id="stores" />,
      type: "item",
      url: "/admin/stores",
      icon: icons.ShopOutlined,
    },
    {
      id: "users",
      title: <FormattedMessage id="users" />,
      type: "item",
      url: "/admin/users",
      icon: icons.UserOutlined,
    },
    {
      id: "notifications",
      breadcrumbs: false,
      title: <FormattedMessage id="Notifications" />,
      type: "item",
      url: "/notifications",
      icon: icons.NotificationOutlined,
    },
    {
      id: "adminNotifications",
      breadcrumbs: false,
      title: <FormattedMessage id="Notifications" />,
      type: "item",
      url: "/admin/notifications",
      icon: icons.NotificationOutlined,
    },
    {
      id: "error-reporting",
      breadcrumbs: false,
      title: <FormattedMessage id="Error-Reporting" />,
      type: "item",
      url: "/admin/error-reporting",
      icon: icons.BugOutlined,
    },
    {
      id: "help_and_docs",
      breadcrumbs: false,
      title: <FormattedMessage id="Help & Docs" />,
      type: "item",
      url: "https://docs.artisanflo.net/",
      icon: icons.QuestionCircleOutlined,
      target: true,
    },
  ],
};

export default other;
